<template>
  <div class="aspirations-section section">
    <div class="section-header-row">
      <h2 class="section-title">
        <span class="icon"><i class="mdi mdi-rocket-launch"></i></span>
        Aspirations
      </h2>
      <add-updates-modal v-if="self" :config="config" type="aspiration"/>
    </div>
    <div v-if="sortedAspirations.length">
      <div
        v-for="(aspiration, idx) in sortedAspirations"
        :key="aspiration._id || idx"
        class="aspiration-block"
      >
        <div class="carousel-item-content">
          <div class="aspiration-date">
            <i class="mdi mdi-calendar"></i>
            {{ formatDate(aspiration.date) }}
          </div>
          <p class="aspiration-text">
            "{{ aspiration.text }}"
          </p>
        </div>
      </div>
    </div>
    <div v-else class="no-aspirations">
      <i class="mdi mdi-emoticon-sad-outline"></i>
      No aspirations found.
    </div>
  </div>
</template>

<script>
import AddUpdatesModal from '@/components/home/AddUpdatesModal.vue'
import moment from 'moment';

export default {
  name: 'AspirationsSection',
  components: {
    AddUpdatesModal
  },
  props: {
    aspirations: {
      type: Array,
      required: true
    },
    self: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      config: {
        headers: { 'Authorization': this.$cookies.get('teamwrkr-token') }
      }
    };
  },
  computed: {
    sortedAspirations() {
      const arr = Array.isArray(this.aspirations) ? this.aspirations : [];
      // Filter out any null/undefined items
      return arr
        .filter(a => a && a.text && a.date)
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    }
  },
  methods: {
    formatDate(dateStr) {
      return moment(dateStr).format('MMMM Do YYYY');
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  background: $color-surface;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  flex: 1 1 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  color: $color-text;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $color-border-muted;
  width: 100%;

  .icon {
    margin-right: 12px;
    color: $color-primary;
    font-size: 1.7rem;
  }
}

.section-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.2rem;
}

.section-title {
  margin-bottom: 0; // Remove bottom margin since the row handles spacing
}

.aspiration-block {
  width: 100%;
  margin-bottom: 1.5rem;
}

::v-deep .button.update-btn {
  margin-bottom: 0rem;
}

.carousel-item-content {
  width: 100%;
  margin: 0 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1.2rem 0.5rem;
  background: $color-surface-soft;
  border-radius: 0.7rem;
  box-shadow: 0 1px 4px rgba(170, 118, 214, 0.06);
  scrollbar-width: thin;
}

.aspiration-text {
  font-size: 1.15rem;
  font-style: italic;
  color: $color-primary;
  text-align: center;
  padding: 0 3rem;
}

.aspiration-date {
  margin-bottom: 0.7rem;
  font-size: 0.98rem;
  color: $color-text-muted;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  justify-content: center;
}

.no-aspirations {
  color: $color-accent;
  font-weight: 600;
  margin-top: 1.5rem;
  text-align: center;
  i {
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }
}

@media screen and (max-width: 900px) {
  .section {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    height: auto !important;
    padding: 1rem 0.5rem !important;
    margin-bottom: 1.2rem !important;
    border-radius: 0.7rem !important;
    box-shadow: 0 1px 6px rgba(170, 118, 214, 0.10) !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }

  .section-title {
    font-size: 1.1rem;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
  }

  .carousel-item-content {
    padding: 0.7rem 0.2rem;
    font-size: 0.98rem;
    max-width: 100%;
  }

  .aspiration-text {
    padding: 0 1rem;
    font-size: 1rem;
  }

  .aspiration-date {
    font-size: 0.92rem;
    margin-bottom: 0.5rem;
  }
}
</style>